<template>
  <Modal
    name="GROUP_REMOVE_HOST_MODAL"
    :title="$t('appointment.group.hostModal.removeHost')"
    ref="modal"
    actions
  >
    <template v-slot:body>
      <div v-if="groupHost">
        <v-alert class="orange lighten-4">
          <span class="d-block orange--text text--darken-2 text-center">
            {{ $t('appointment.group.hostModal.removeHostWarningMessage') }}
          </span>
        </v-alert>
        <h6 class="text-uppercase grey--text mb-0">
          {{ $t('appointment.group.hostModal.host') }}
        </h6>
        <p class="mb-0">
          {{ groupHost.name }}
        </p>
        <p class="body-2 mb-1">
          {{ groupHost.username }}
        </p>
      </div>
    </template>
    <template v-slot:actions>
       <v-btn
        @click="closeAllModals"
        :disabled="isLoading"
        elevation="0"
        class="mr-5"
        text
      >
        {{ $t('appointment.buttons.cancel') }}
      </v-btn>

      <v-btn
        v-if="groupHost"
        @click="removeHost"
        :loading="isLoading"
        color="warning"
        elevation="0"
      >
        {{ $t('appointment.group.hostModal.removeHost') }}
      </v-btn>
    </template>
  </Modal>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import { required } from '@/util/errorHandling'

import Modal from '@/components/app/Modal'
import HostSelect from '@/components/host/HostSelect'

export default {
  name: 'ModalGroupRemoveHost',

  components: {
    Modal,
    HostSelect,
  },

  props: {
    groupId: {
      type: String,
      required: true,
    },

    groupHost: {
      type: Object,
      default: null,
    },
  },

  methods: {
    ...mapActions(['setGroupHost', 'unassignGroupHost']),
    ...mapMutations(['closeAllModals']),

    removeHost() {
      this.isLoading = true

      Promise
        .resolve(this.unassignGroupHost({ group_id: this.groupId }))
        .finally(() => {
          this.isLoading = false
          this.$parent.$parent.refreshMap()
        })
    }
  },

  data() {
    return {
      isLoading: false,
      host: null,
    }
  },

  mounted() {
    this.$watch(() => this.$refs.modal.dialog, (value) => {
      if (value) this.host = null
    })
  }
}
</script>
